module.exports = __webpack_public_path__ + "images/cloud-top.0a409ad7.png";